import { Button } from "../../../../components/custom/custom-button";

interface WizardActionBarProps {
  onCancel: () => void;
  onSaveDraft: () => void;
  onPrimary: () => void;
  primaryLabel: string;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
}

export default function WizardActionBar({
  onCancel,
  onSaveDraft,
  onPrimary,
  primaryLabel,
  primaryDisabled,
  primaryLoading,
}: WizardActionBarProps) {
  return (
    <div className="flex items-center gap-[12px] pt-[24px]">
      <Button
        variant="ghost"
        className="bg-[#FDECEC] text-[#DC2626] hover:bg-[#FDECEC] hover:text-[#DC2626]"
        onClick={onCancel}
      >
        Cancel
      </Button>
      <Button variant="secondary"
        className="disabled:bg-[#734792]/10 text-[#734792]"
       onClick={onSaveDraft}>
        Save as draft
      </Button>
      <Button
        onClick={onPrimary}
                className="disabled:bg-[#734792]/10 disabled:text-[#ffffff]"

        disabled={primaryDisabled}
        isLoading={primaryLoading}
      >
        {primaryLabel}
      </Button>
    </div>
  );
}
